import React from "react";
import { ExpertServiceType } from "../../../pages/expert/service/ExpertServiceNotice";
import ServiceNoticeTab from "./ServiceNoticeTab";
import UserServiceAgreeMent from "./UserServiceAgreeMent";
import { css } from "@emotion/react";
import { useState } from "react";
import UserAgentNotice from "./UserAgentNotice";
import UserConsultNotice from "./UserConsultNotice";
import { transferToNative } from "@src/lib/WebAppBridge";
import UserBidAgentNotice from "./UserBidAgentNotice";

const ServiceNoticeForUser = ({ serviceType }: { serviceType: ExpertServiceType }) => {
    const [isAgree, setIsAgree] = useState(false);
    const [isHideForWeek, setIsHideForWeek] = useState(false);
    const handleClickNext = () => {
        transferToNative(JSON.stringify({ serviceType, isHideForWeek, userType: "user" }), "closeServiceNotice");
    };
    return (
        <div>
            <ServiceNoticeTab userType="user" serviceType={serviceType} />
            {serviceType == ExpertServiceType.경매대행 && <UserAgentNotice />}
            {serviceType == ExpertServiceType.매물컨설팅 && <UserConsultNotice />}
            {serviceType == ExpertServiceType.매수신청대리 && <UserBidAgentNotice />}
            {/* {serviceType == ExpertServiceType.임장동행 && <UserAccompanyNotice />} */}
            <UserServiceAgreeMent
                onAllAgree={() => setIsAgree(true)}
                onDisAgree={() => setIsAgree(false)}
                isHideForWeek={isHideForWeek}
                setIsHideForWeek={setIsHideForWeek}
                serviceType={serviceType}
            />
            <div css={ButtonContainerStyle}>
                <button css={ButtonStyle(isAgree)} disabled={!isAgree} onClick={handleClickNext}>
                    다음
                </button>
            </div>
        </div>
    );
};

export default ServiceNoticeForUser;

const ButtonContainerStyle = css`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 14px 14px 24px 14px;
`;

const ButtonStyle = (isAgree: boolean) => css`
    width: 100%;
    padding: 14px 0;
    background-color: ${isAgree ? "#2275EE" : "#c3c3c3"};
    color: #ffffff;
    border-radius: 14px;
    font-size: 18px;
`;
